module.exports = __webpack_public_path__ + "static/media/grid_screen_4.516bc076.jpg";